import type { ReactNode } from 'react';

import type { DictionaryService } from '../DictionaryService';
import type { RenderableDynamicValues, DynamicValues } from '../types';

import { DictionaryValue } from './DictionaryValue';
import { useDictionaryValue, useRenderableDynamicValues } from './hooks';

export interface PlainDictionaryTextProps {
  tk: string;
  placeholder?: string;
  markdown?: boolean;
  dynamicValues?: RenderableDynamicValues;
}

export interface DictionaryTextProps<File> extends PlainDictionaryTextProps {
  service: DictionaryService<File>;
}

export const DictionaryText = <File,>({
  service,
  tk,
  placeholder,
  markdown,
  dynamicValues,
}: DictionaryTextProps<File>): ReactNode => {
  const renderableDynamicValues = useRenderableDynamicValues(dynamicValues);
  const value = useDictionaryValue(
    service,
    tk,
    !renderableDynamicValues ? (dynamicValues as DynamicValues) : undefined
  );

  return (
    <DictionaryValue
      value={value || placeholder || ''}
      markdown={markdown}
      renderableDynamicValues={renderableDynamicValues}
      dynamicValues={dynamicValues as Record<string, string | number>}
    />
  );
};
